import styled from 'styled-components';

import { SmallSubtitle } from '../../../../../foundations/typefaces/SmallSubtitle';

interface StyledSmallSubtitleProps {
  $color?: string;
}

export const StyledSmallSubtitle = styled(SmallSubtitle)<StyledSmallSubtitleProps>(
  ({ theme: { color: themeColor }, $color }) => ({
    color: $color ?? themeColor.content.reversed.default(),
    textTransform: 'uppercase',
  }),
);

interface WrapperProps {
  $animated: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { size, color, transition }, $animated }) => ({
    borderRadius: size.units(0.75),
    padding: `${size.units(0.5)} ${size.units(0.75)}`,
    backgroundColor: color.background.reversed.default(0.8),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
    transition: transition.standard('max-width'),
    gap: $animated ? 0 : size.units(0.5),
    maxWidth: $animated ? 0 : 'auto',
    minWidth: size.units(3.5),
    whiteSpace: 'nowrap',

    [StyledSmallSubtitle]: {
      paddingLeft: $animated ? size.units(1) : 0,
    },
  }),
);

export const StyledIcon = styled.div(({ theme: { color, size } }) => ({
  color: color.content.reversed.default(),
  minWidth: size.units(2),
  width: size.units(2),
}));
